/* eslint @ngrx/prefer-effect-callback-in-block-statement: off */
import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs';

import { CompanyActions } from './company-state.actions';
import { selectCompanyId } from './company-state.selectors';
import { CompanyService } from './company.service';

@Injectable()
export class CompanyStateEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private companyService = inject(CompanyService);

  updateCompany$ = createEffect(() => this.actions$.pipe(ofType(CompanyActions.handleCompanyUpdate)));

  updateCompanyTheme$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.handleCompanyUpdate),
      filter(({ changes }) => !!changes?.settings?.colorBranding),
      map(({ changes }) => CompanyActions.updateTheme({ colorBranding: changes.settings.colorBranding }))
    )
  );

  refreshCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.refreshCurrentCompanyFromDb),
      concatLatestFrom(() => this.store.select(selectCompanyId)),
      switchMap(([, companyId]) =>
        this.companyService.getCompanyById(companyId).pipe(map(company => CompanyActions.init({ company })))
      )
    )
  );
}
